import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { FileImageService } from "../api";

export const actionBulkUpload = createAsyncThunk(
  "file/bulk-upload",
  async (data, { rejectWithValue }) => {
    try {
      const res = await FileImageService.doBulkUpload(data);
      if (res.data) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const fileImageSlice = createSlice({
  name: "fileImage",
  initialState: {
    bulkUpload: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // list Address
      .addCase(actionBulkUpload.pending, (state) => {
        state.bulkUpload.loading = true;
      })
      .addCase(actionBulkUpload.fulfilled, (state, action) => {
        state.bulkUpload.loading = false;
        state.bulkUpload.error = action.payload;
        state.bulkUpload.data = {};
      })
      .addCase(actionBulkUpload.rejected, (state, action) => {
        state.bulkUpload.loading = false;
        state.bulkUpload.data = action.payload;
        state.bulkUpload.error = "";
      });
  },
});

export default fileImageSlice.reducer;
export const { actions, reducer } = fileImageSlice;
